import { render, staticRenderFns } from "./leftItem.vue?vue&type=template&id=11586244&scoped=true"
import script from "./leftItem.vue?vue&type=script&lang=js"
export * from "./leftItem.vue?vue&type=script&lang=js"
import style0 from "./leftItem.vue?vue&type=style&index=0&id=11586244&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11586244",
  null
  
)

export default component.exports